import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../models/Action";
import { IDENTITY_SYSTEM } from "../../../module/constants";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import { EMPLOYEE } from "./constants";
import emptyState from "./emptyState";
import moment from "moment";
import { compose } from "redux";

const ACTION_HANDLERS = {
  [actionTypes.MODIFY_DELEGATIONS]: (state: any, action: any) =>
    immutableSet(["delegations"], action.delegations, state),
  [actionTypes.MODIFY_SELECTED_ROLE]: (state: any, action: any) =>
    immutableSet(["selectedRole"], action.selectedRole, state),
  [actionTypes.MODIFY_SELECTED_USERS_DELEGATION]: (state: any, action: any) =>
    immutableSet(["selectedUsers"], action.selectedUsers, state),

  [actionTypes.DELEGATION_REQUEST]: (state: any, action: any) =>
    immutableSet(["delegationsLoader"], true, state),

  [actionTypes.DELEGATION_REQUEST_SUCCESS]: (state: any, action: any) => {
    let tempDelegations: any[] = [];
    action.payload.forEach((delegation: any) => {
      let tempObj: {} = {};
      Object.assign(tempObj, { delegation_id: delegation.delegationId });
      Object.assign(tempObj, {
        delegated:
          delegation.delegatedInfo.name +
          " " +
          delegation.delegatedInfo.surname,
      });
      Object.assign(tempObj, { role: delegation.role });
      let begin_date = delegation.beginDate
        ? moment(delegation.beginDate).format("DD/MM/YYYY - HH:mm")
        : "";
      Object.assign(tempObj, { begin_date: begin_date });
      let end_date = delegation.endDate
        ? moment(delegation.endDate).format("DD/MM/YYYY - HH:mm")
        : "";
      Object.assign(tempObj, { end_date: end_date });

      tempDelegations.push(tempObj);
    });
    return compose(
      immutableSet(["delegations"], tempDelegations),
      immutableSet(["delegationsLoader"], false)
    )(state);
  },
  [actionTypes.DELEGATION_REQUEST_FAILURE]: (state: any, action: any) => {
    return compose(
      immutableSet(["delegations"], action),
      immutableSet(["delegationsLoader"], false)
    )(state);
  },

  [actionTypes.DELETE_DELEGATION_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return immutableSet(["callState"], IResponseState.SUCCESS, state);
  },
  [actionTypes.DELETE_DELEGATION_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => {
    return immutableSet(["callState"], IResponseState.ERROR, state);
  },

  [actionTypes.MODIFY_DELEGATION_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return immutableSet(["callState"], IResponseState.SUCCESS, state);
  },
  [actionTypes.MODIFY_DELEGATION_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => {
    return immutableSet(["callState"], IResponseState.ERROR, state);
  },

  [actionTypes.DELEGATION_USER_REQUEST]: (state: any, action: any) =>
    immutableSet(["usersLoader"], true, state),
  [actionTypes.DELEGATION_USER_REQUEST_SUCCESS]: (state: any, action: any) => {
    const tempList: any[] = [];
    action.payload &&
      action.payload.length > 0 &&
      action.payload.forEach((item: any) => {
        const tempObj = {
          ...item,
          id_user: item.id,
          identitySystemId:
            IDENTITY_SYSTEM[
              item.identitySystemId as keyof typeof IDENTITY_SYSTEM
            ],
        };
        delete tempObj["id"];
        delete tempObj["netsId"];
        delete tempObj["netsPersonId"];
        delete tempObj["netsOrgunitId"];
        tempList.push(tempObj);
      });
    return compose(
      immutableSet(["users"], tempList),
      immutableSet(["usersLoader"], false)
    )(state);
  },
  [actionTypes.DELEGATION_USER_REQUEST_FAILURE]: (state: any, action: any) => {
    return compose(
      immutableSet(["users"], null),
      immutableSet(["usersLoader"], false)
    )(state);
  },

  [actionTypes.DELEGATION_USER_BAO_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const tempList: any = [];
    action.payload &&
      action.payload.length > 0 &&
      action.payload.forEach((item: any) => {
        const tempObj = {
          ...item,
          id_user: item.id,
        };
        delete tempObj["id"];
        if (item.type === EMPLOYEE) {
          tempList.push(tempObj);
        }
      });
    return immutableSet(["users"], tempList, state);
  },
  [actionTypes.DELEGATION_USER_BAO_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => {
    return immutableSet(["users"], null, state);
  },

  [actionTypes.CREATE_DELEGATION]: (state: any, action: any) => {
    return immutableSet(["callState"], IResponseState.PENDING, state);
  },
  [actionTypes.CREATE_DELEGATION_SUCCESS]: (state: any, action: any) => {
    return immutableSet(["callState"], IResponseState.SUCCESS, state);
  },
  [actionTypes.CREATE_DELEGATION_FAILURE]: (state: any, action: any) => {
    return immutableSet(["callState"], IResponseState.ERROR, state);
  },

  [actionTypes.RESET_DELEGATION_STATE]: (state: any, action: any) => emptyState,
  [actionTypes.RESET_CALL_STATE]: (state: any, action: any) => {
    return immutableSet(["callState"], IResponseState.PENDING, state);
  },
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
